import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export function sendFriendRequest(email) {
  return axios
    .post(`${BASE_URL}/sendFriendRequest`, { email })
    .then(({ data }) => data);
}

export function loadFriends(skip, limit) {
  return axios
    .post(`${BASE_URL}/getFriends`, { skip, limit })
    .then(({ data }) => data);
}

export function removeFriend(friendId) {
  return axios
    .post(`${BASE_URL}/removeFriend`, { friendId })
    .then(({ data }) => data);
}

export function updateFriendRequestStatus(id, status) {
  return axios
    .patch(`${BASE_URL}/updateFriendRequestStatus`, { id, status })
    .then(({ data }) => data);
}

export function getFriendRequestNotifications() {
  return axios
    .get(`${BASE_URL}/getFriendRequestNotifications`)
    .then(({ data }) => data);
}
